import { withInstall } from '@code-monkey-ui/utils'
import Drawer from './src/drawer.vue'

export const ElDrawer = withInstall(Drawer)
export default ElDrawer

export * from './src/drawer'
